module.exports = __webpack_public_path__ + "img/whiteChrysanthemum.8fbf8fc3.png";